export const DefaultModalOptions = {scrollable: true, size: 'xl', fullscreen: 'xl'};
